import $ from 'jquery'
import _ from 'underscore'
import messageResource from '../../messageResource'
import PermissionsTemplateButtonControllerWithoutChoosing from '../userManagement/permissionsTemplates/PermissionsTemplateButtonControllerWithoutChoosing'
import ATInviteSeveralUsersRow from './ATInviteSeveralUsersRow'
import DropdownList from '../../controls/DropdownList'
import {DEFAULT_PERMISSIONS_TEMPLATE_ID} from '../../constants'
import InviteSeveralUsersLightBox from './InviteSeveralUsersLightBox'
import {unsafe_selectWithState} from '../../redux/utils'
import {isBTYEnabled, isLTTEnabled, isPTOEnabled, isSDBEnabled, isURAEnabled} from '../../features/selectors'

function ATInviteSeveralUsersLightBox() {}

ATInviteSeveralUsersLightBox.prototype = _.create(InviteSeveralUsersLightBox.prototype, {
    PERMISSIONS_TEMPLATE_SELECTOR_ROW:
    "<tr class='permissionsTemplateSelectorRow <%= isLastRow ? \'last\' : \'\'%>'>" +
    "   <td>" +
    "       <div>" +
    "           <%= escapeHtmlSymbols(name) + (id == DEFAULT_PERMISSIONS_TEMPLATE_ID ? ' ' + defaultTemplateLabel : '')%>" +
    "       </div>" +
    "   </td>" +
    "</tr>",

    init: function({inviteUsersData, onChangePermissionsTemplates, onHideCallback}) {
        this.templatesList = new DropdownList().init(
            "inviteSeveralUsersTemplatesDropdownList",
            "templatesDropdownList",
            this.PERMISSIONS_TEMPLATE_SELECTOR_ROW,
            this._createTemplatesData(inviteUsersData.userManagementData.permissionsTemplates),
            document.getElementById(this._getLightBoxId())
        );

        this.currentPermisisonsTemplates = inviteUsersData.userManagementData.permissionsTemplates;
        InviteSeveralUsersLightBox.prototype.init.call(this, inviteUsersData);

        var $permissionTemplatesMenuButton = $(this.lightBoxEl).find(".innerContent .editPermissionsTemplateButton");
        var $editPermissionsTemplateMenu = $(this.lightBoxEl).find(".innerContent .editPermissionsTemplateMenu");

        this.permissionsTemplatesButtonController = new PermissionsTemplateButtonControllerWithoutChoosing(
            $editPermissionsTemplateMenu,
            $permissionTemplatesMenuButton,
            onChangePermissionsTemplates
        ).init();
        this.permissionsTemplatesButtonController.setState({
            templates: inviteUsersData.userManagementData.permissionsTemplates,
            isURAEnabled: unsafe_selectWithState(isURAEnabled),
            isBTYEnabled: unsafe_selectWithState(isBTYEnabled),
            isPTOEnabled: unsafe_selectWithState(isPTOEnabled),
            isSDBEnabled: unsafe_selectWithState(isSDBEnabled),
            isLTTEnabled: unsafe_selectWithState(isLTTEnabled),
        });

        this.onHideCallback = onHideCallback;

        var hideMenuOnScrollContentCallback = _.bind(function() {
            this.templatesList.hide();
        }, this);

        $(this.lightBoxEl).find(".innerContent").off("scroll.templatesDropdownList", hideMenuOnScrollContentCallback)
                          .on("scroll.templatesDropdownList", hideMenuOnScrollContentCallback);

        return this;
    },

    _getDefaultTemplateName: function() {
        return _.findWhere(this.currentPermisisonsTemplates, {id: DEFAULT_PERMISSIONS_TEMPLATE_ID}).name + " " +
               messageResource.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template');
    },

    _generateTable: function() {
        this.rows = [];
        var $tableContainer = this.innerContent.find(".tableContainer");
        $tableContainer.empty();
        var defaultTemplateName = this._getDefaultTemplateName();
        var $table = $('<table>');
        var row;
        for (var i = 0; i < this.INITIAL_NUMBER_OF_ROWS; i++) {
            this._addRow($table,
                i,
                i === 0 ? "firstRow" : (i === this.INITIAL_NUMBER_OF_ROWS - 1 ? "lastRow" : ""),
                defaultTemplateName);
        }
        $tableContainer.append($table);
    },

    _createTemplatesData: function(permissionsTemplatesData) {
        var templatesData = [];
        const defaultTemplateLabel = messageResource.getMessage('userlist.userdata.permissions_templates.js.menu.row.default_template')
        _.each(permissionsTemplatesData, function(data) {
            templatesData.push({
                id: data.id,
                name: data.name,
                isLastRow: false,
                defaultTemplateLabel: defaultTemplateLabel
            });
        });
        templatesData[templatesData.length - 1].isLastRow = true;
        return templatesData;
    },

    updatePermissionsTemplatesData: function(templatesData) {
        this.permissionsTemplatesButtonController.setState({
            templates: templatesData
        })
        this.templatesList.updateData(this._createTemplatesData(templatesData))
        this.currentPermisisonsTemplates = templatesData
        this._updateRows()
    },

    hide: function() {
        InviteSeveralUsersLightBox.prototype.hide.apply(this, arguments);
        if (this.onHideCallback) {
            this.onHideCallback();
        }
    },

    _addEmptyRows: function(number) {
        if (this.rows.length + number > 10) {
            $(this.lightBoxEl).addClass("scrollable");
        }
        var rowCount = this.rows.length;
        this.rows[rowCount - 1].setSpecialRowClasses("");
        var defaultTemplateName = this._getDefaultTemplateName();
        var $table = this.innerContent.find(".tableContainer table");
        for (var i = 0; i < number; i++) {
            this._addRow($table,
                i + rowCount,
                i === number - 1 ? "lastRow" : "",
                defaultTemplateName);
        }
        this.updateUI();
    },

    _addRow: function($table, number, specialClass, defaultTemplateName) {
        var row = new ATInviteSeveralUsersRow().init(number,
            specialClass,
            $.proxy(this._validateCallback, this),
            $.proxy(this._changesCallback, this),
            this.templatesList,
            DEFAULT_PERMISSIONS_TEMPLATE_ID,
            defaultTemplateName,
            this.errorTooltip);
        this.rows.push(row);
        $table.append(row.getElement());
    },

    _updateRows: function() {
        this.rows.forEach(row => {
            const template = this.currentPermisisonsTemplates.find(template => template.id === row.permissionsTemplateId)
            row.setTemplateName({
                templateId: template.id,
                templateName: template.name,
            })
            row.updateUI()
        })
    }
});

export default ATInviteSeveralUsersLightBox



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/ATInviteSeveralUsersLightBox.js